module.exports = __webpack_public_path__ + "img/hr-diesel-locomotive-mask-8.cf3849d5.png";